import clsx from 'clsx';
import React from 'react';

import { SvgIconProps } from './SvgIcon';

const InkVialIcon = ({ fill = 60, ...props }: SvgIconProps & { fill?: number }) => {
  // Calculate liquid height based on fill percentage (0-100)
  // The vial's liquid area roughly spans from y=120 to y=167 (47 units)
  const maxHeight = 44;
  const maxY = 172;

  // Calculate the actual height and starting Y position based on fill percentage
  const liquidHeight = (fill / 50) * maxHeight;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="30 28 141 154"
      width={props.size}
      className={clsx('tw-relative', props.offsetUp ? '-tw-top-[0.08em]' : null, props.className)}
    >
      <path
        fill="currentColor"
        d={`M161,${maxY}c0,.56-.89,1-1.73,1H41.5c-1.46,0-2.34-.44-2.34-1l.14-${liquidHeight}c0-.56.89-1,1.73-1h117.5c1.46,0,2.34.44,2.34,1l-.14,${liquidHeight}Z`}
      />
      <path
        fill="currentColor"
        d="M153.99,61.85h-27.89v-5.15h0c6.56-1.74,11.4-7.71,11.4-14.82,0-8.48-6.87-15.35-15.35-15.35h-44.31c-8.48,0-15.35,6.87-15.35,15.35,0,6.58,4.15,12.18,9.97,14.36v5.61h-26.45c-8.28,0-15,6.72-15,15v87.63c0,8.28,6.72,15,15,15h107.98c8.28,0,15-6.72,15-15v-87.63c0-8.28-6.72-15-15-15ZM72.84,41.61c0-2.76,2.24-5,5-5h44.32c2.76,0,5,2.24,5,5h0c0,2.77-2.24,5.01-5,5.01h-44.32c-2.76,0-5-2.24-5-5h0ZM159,164.49c0,2.76-2.24,5-5,5H46c-2.76,0-5-2.24-5-5v-87.64c0-2.76,2.24-5,5-5h34.64c1.2,0,2.16-.97,2.16-2.16v-13.35l33.29.28v13.07c0,1.2.97,2.16,2.16,2.16h35.74c2.76,0,5,2.24,5,5v87.64Z"
      />
    </svg>
  );
};

export const InkVialSegmentedIcon = (props: SvgIconProps & { segments: number; placeholder?: boolean }) => {
  const fillColor = props.placeholder ? '#eeeeee' : '#fafafa';
  return (
    <div className="tw-relative tw-inline-block" style={{ width: props.size }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 28 141 154"
        width={props.size}
        className={clsx('tw-relative', props.offsetUp ? '-tw-top-[0.08em]' : null, props.className)}
      >
        <path
          fill={fillColor}
          d="M142.16,66.45h-17.89v-12.68c4.75,0,8.55-3.98,8.24-8.8-.28-4.4-4.12-7.73-8.52-7.73h-49.33c-4.4,0-8.24,3.33-8.52,7.73-.3,4.81,3.5,8.8,8.24,8.8v12.68h-16.55c-12.15,0-22,9.85-22,22v69.12c0,12.15,9.85,22,22,22h84.32c12.15,0,22-9.85,22-22v-69.12c0-12.15-9.85-22-22-22ZM154.87,158.27c0,6.63-5.37,12-12,12H57.13c-6.63,0-12-5.37-12-12v-70.53c0-6.63,5.37-12,12-12h24.86c1.11,0,2.01-.9,2.01-2.01v-18.48c0-.98.79-1.77,1.77-1.77h27.41c.98,0,1.77.79,1.77,1.77v18.48c0,1.11.9,2.01,2.01,2.01h25.88c6.63,0,12,5.37,12,12v70.53Z"
        />
        <rect x="45" y="75" width="110" height="100" fill={fillColor} />
        <rect x="80" y="40" width="40" height="38" fill={fillColor} />
      </svg>

      {/* Liquid segments container */}
      <div
        className={clsx(
          'tw-absolute tw-bottom-0 tw-left-0 tw-right-0',
          'tw-overflow-hidden',
          'tw-flex tw-flex-col tw-gap-y-1',
        )}
        style={{
          bottom: '9%',
          height: '60%',
          left: '12%',
          width: '75.5%',
        }}
      >
        {Array.from({ length: props.segments }, (_, index) => (
          <div
            key={index}
            className={clsx(
              'tw-flex-1',
              props.placeholder ? 'tw-bg-[#e0e0e0]' : 'tw-bg-[#212121]',
              index === 0 ? 'tw-rounded-t-[1rem]' : 'tw-rounded-t',
              index === props.segments - 1 ? 'tw-rounded-b-[1rem]' : 'tw-rounded-b',
              'tw-flex tw-items-center tw-justify-center',
            )}
          >
            {!props.placeholder ? (
              <span
                className={clsx(
                  'tw-text-white',
                  props.segments < 2
                    ? 'tw-text-4xl'
                    : props.segments < 3
                      ? 'tw-text-2xl'
                      : props.segments < 5
                        ? 'tw-text-xl'
                        : props.segments < 6
                          ? 'tw-text-lg'
                          : props.segments < 7
                            ? 'tw-text-sm'
                            : 'tw-text-xs',
                )}
              >
                1⁄{props.segments}
              </span>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InkVialIcon;
